
/*
 *   File : bank.js
 *   Author URI : https://evoqins.com
 *   Description : Screen to add bank details.
 *   Integrations : null
 *   Version : v1.1
 */
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import { LinkText, GradientButton } from "../../../Components/Cta";
import { CustomTextInput, CustomSearchSelectBox } from "../../../Components/FormElements";
import { FilePreview } from "../../../Components/Cards";
import CustomFilePicker from "../../../Components/FormElements/file-upload";

import APIService from "../../../Services/api-service";
import { _getKycProfile } from "../../../Helper/api";
import { _isFileTypeAllowed } from "../../../Helper/helper-function";
import { _uploadDocumentToS3 } from "../../../Services/aws-service";
import Store from "../../../Store";

const AC_TYPE = [
    { value: 1, label: 'Current' },
    { value: 2, label: 'Savings' },
    { value: 3, label: 'Fixed Deposit' },
    { value: 4, label: 'NRI' }
]
const BankDetail = (props) => {
    const location = useLocation();
    const BANK_DATA = useSelector(state => state.MT_ADMIN_STORE.KYC_DATA.bank_details);

    const [bankName, setBankName] = useState(BANK_DATA.bank_name !== null ? BANK_DATA.bank_name : "");
    const [acNumber, setAcNumber] = useState(BANK_DATA.account_number !== null ? BANK_DATA.account_number : "");
    const [confirmAcNumber, setConfirmAcNumber] = useState(BANK_DATA.account_number !== null ? BANK_DATA.account_number : "");
    const [acType, setAcType] = useState(AC_TYPE[0]);
    const [ifsc, setIfsc] = useState(BANK_DATA.ifsc_code !== null ? BANK_DATA.ifsc_code : "");
    const [bankError, setBankError] = useState('');
    const [acNumberError, setAcNumberError] = useState('');
    const [confirmAcNumberError, setConfirmAcNumberError] = useState('');
    const [ifscError, setIfscError] = useState('');
    const [bankStatement, setBankStatement] = useState(null);
    const [bankStatementUrl, setBankStatementUrl] = useState(BANK_DATA.bank_statement_url);
    const [bankStatementError, setBankStatementError] = useState(null);

    const [cancelledCheque, setCancelledCheque] = useState(BANK_DATA.bank_cheque_url);
    const [cancelledChequeUrl, setCancelledChequeUrl] = useState(null);
    const [cancelledChequeError, setCancelledChequeError] = useState(null);
    const [apiLoader, setApiLoader] = useState(false);

    const [fileLoader, setFileLoader] = useState(false);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {
        if (BANK_DATA.bank_statement_url !== null) {
            const decodedURL = decodeURIComponent(decodeURIComponent(BANK_DATA.bank_statement_url));
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setBankStatement(fileName);
        }
        if (BANK_DATA.bank_cheque_url) {
            const decodedURL1 = decodeURIComponent(decodeURIComponent(BANK_DATA.bank_cheque_url));
            const fileName1 = decodedURL1.split('?')[0].split("/").pop();
            setCancelledCheque(fileName1);
        }

    }, [BANK_DATA])

    // Form validation
    function _validateBankDetail() {
        let valid_form = true;
        let ifsc_regex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;
        if (bankName.length === 0) {
            valid_form = false;
            setBankError('Please provide bank name');
        }
        if (acNumber.length === 0) {
            valid_form = false;
            setAcNumberError('Please provide account number');
        } else if (acNumber.length < 12 || acNumber.length > 18) {
            valid_form = false;
            setAcNumberError('Invalid Account number ');
        }
        // if (ifsc.length === 0 ){
        //     valid_form = false;
        if (ifsc.length === 0) {
            setIfscError('Please provide IFSC code');
        }
        else if (ifsc_regex.test(ifsc) === false) {
            valid_form = false;
            setIfscError('Invalid IFSC code');
        }
        if (valid_form === true) {
            setBankName('');
            setAcNumber('');
            setIfsc('');
            props.updateProgress(4);
        }
    };

    // Form validation
    function _submitBankDetail() {
        let valid_form = true;
        let ifsc_regex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;

        if (acNumber.length === 0) {
            valid_form = false;
            setAcNumberError('Please provide account number');
        } else if (acNumber.length < 6 || acNumber.length > 18) {
            valid_form = false;
            setAcNumberError('Invalid Account number ');
        }


        if (confirmAcNumber.length === 0) {
            valid_form = false;
            setConfirmAcNumberError('Please provide account number');
        } else if (confirmAcNumber.length < 6 || confirmAcNumber.length > 18) {
            valid_form = false;
            setConfirmAcNumberError('Invalid Account number ');
        } else if (acNumber !== confirmAcNumber) {
            valid_form = false;
            setConfirmAcNumberError('Account number not matching with previous');
        }
        // if (ifsc.length === 0 ){
        //     valid_form = false;
        if (ifsc.length === 0) {
            setIfscError('Please provide IFSC code');
        }
        else if (ifsc_regex.test(ifsc) === false) {
            valid_form = false;
            setIfscError('Invalid IFSC code');
        }


        if (bankStatement === null && cancelledCheque === null) {
            valid_form = false;
            setBankStatementError('Please upload bank statement or cancelled cheque');
        }

        if (valid_form === true) {
            _addBank();

        }
    };

    function _handleBankUpload(path, file) {
        // eslint-disable-next-line
        // var file_formatted = file.replace(/^.*[\\\/]/, '').split('/');
        // setBankStatement(file_formatted);
        // setBankStatementError('');
        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    _fileUpload(file_formatted, file, 1);
                } else {
                    setBankStatementError("File size should be less than 5mb");
                }
            }
            else {
                setBankStatementError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }
    function _handleCheque(path, file) {
        // eslint-disable-next-line
        var file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    _fileUpload(file_formatted, file, 2);
                } else {
                    setCancelledChequeError("File size should be less than 5mb");
                }
            }
            else {
                setCancelledChequeError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }

    function _navigateBack() {
        props.updateProgress(2);
    }

    //API :: file upload api
    const _fileUpload = (key, file, type) => {
        setBankStatementError("");
        setCancelledChequeError("");
        setFileLoader(type);
        let url = "general/file-upload";
        let body = {
            "key": `support/${key}`
        }

        APIService(true, url, body).then((response) => {
            if (response.status_code === 200) {
                setFileLoader(type);

                // s3 helper
                _uploadDocumentToS3(response.data, key, file).then((result) => {

                    setFileLoader(false);
                    if (type === 1) {
                        setBankStatement(key);
                        setBankStatementUrl(response.data.view_info); // file got uploaded successfully
                    } else {
                        setCancelledCheque(key);
                        setCancelledChequeUrl(response.data.view_info);
                    }

                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });

            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }

    function _addBank() {
        setApiLoader(true);
        let url = 'kyc/add-bank-v2';
        let payload = JSON.stringify({
            "account_holder_name": "",
            "account_number": confirmAcNumber,
            "account_type_id": 147,
            "ifsc_code": ifsc,
            "is_default": true,
            "is_manual": true,
            "primary": true,
            "bank_cheque_url": cancelledCheque == null ? null : cancelledChequeUrl,
            "bank_statement_url": bankStatement === null ? null : bankStatementUrl,
            "customer_id": location.state.user_id,
            "is_review": props.edit,
        });
        APIService(true, url, payload).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                if (response.kyc_data) {
                    Store.dispatch({
                        type: 'GET_KYC_DATA',
                        payload: response.kyc_data
                    });
                }
                if (response.bank_verification_needed === true) {
                    toast.error(response.data, {
                        type: 'error'
                    });
                } else {
                    toast.success(response.data || "Bank details added successfully");
                    props.updateProgress(response.kyc_data?.is_review ? 7 : 6, props.text, props.is_manual);
                }
            } else {

                toast.error(response.message, {
                    type: 'error'
                })
            }
            setApiLoader(false);
        })
    }
    return (

        props.is_manual ?
            <>
                <div className="row">
                    <div className="col-md-8">
                        <h4 className="color-jett-black e-inter-bold e-font-24 mb-2">Add your bank account</h4>
                        <p className="color-outer-space e-poppins-regular e-font-16 mb-3">Verify and register your account with mt wealth. As per regulatory requirements you can invest through a registered bank account only.</p>
                        <h6 className="color-jett-black e-poppins-medium e-font-16 mb-2">Add bank details</h6>
                        <p className="color-outer-space e-poppins-regular e-font-16 mb-4">
                            Please ensure that the details you provide match exactly with the information on your submitted proof. Any discrepancies may result in verification delays or rejection
                        </p>

                        <div className="col-lg-6 col-12 mt-4">
                            <CustomTextInput value={acNumber}
                                label={`${props.text} account number`}
                                postfix="*"
                                type="number"
                                max={18}
                                error={acNumberError}
                                onEnter={_submitBankDetail}
                                valueChange={(e) => {
                                    setAcNumber(e);
                                    setAcNumberError('')
                                }} />
                        </div>

                        <div className="col-lg-6 col-12 mt-4 pt-3">
                            <CustomTextInput value={confirmAcNumber}
                                label={`Re-enter current account number`}
                                postfix="*"
                                max={18}
                                error={confirmAcNumberError}
                                type="number"
                                onEnter={_submitBankDetail}
                                valueChange={(e) => {
                                    setConfirmAcNumber(e);
                                    setConfirmAcNumberError("");
                                }} />
                        </div>


                        <div className="col-lg-6 col-12 mt-4 pt-3">
                            <CustomTextInput value={ifsc}
                                label="IFSC Code"
                                postfix="*"
                                error={ifscError}
                                max={12}
                                uppercase={true}
                                inputClass="text-uppercase"
                                onEnter={_submitBankDetail}
                                valueChange={(e) => { setIfsc(e); setIfscError('') }} />
                        </div>

                        <h5 className="color-jett-black e-poppins-medium e-font-18 mb-2 mt-4">Upload bank proof</h5>
                        <p className="color-outer-space e-poppins-regular e-font-16 mb-2">
                            Please provide any of the following documents as bank proof for your HUF account:
                        </p>
                        <span className="color-jett-black e-font-12 e-poppins-medium">Upload {props.text} Bank Statement (Current account) or Cancelled Cheque</span>
                        <div className="row pt-3">
                            <div className="col-lg-6">
                                <p className="color-black e-font-14 e-poppins-medium mb-2">Upload {props.text} bank statement</p>
                                {
                                    bankStatement === null ?
                                        (
                                            <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                className="e-select-file"
                                                error={bankStatementError}
                                                type={1}
                                                loading={fileLoader === 1 ? true : false}
                                                onSelectFile={_handleBankUpload} />
                                        ) : (
                                            <FilePreview fileName={bankStatement}
                                                clearFile={() => {
                                                    setBankStatement(null);
                                                    setBankStatementUrl("");
                                                }} />
                                        )
                                }
                            </div>
                            <div className="col-lg-6  mt-lg-0 pt-lg-0 mt-4">
                                <p className="color-black e-font-14 e-poppins-medium mb-2">Upload cancelled cheque</p>
                                {
                                    cancelledCheque === null ?
                                        (
                                            <CustomFilePicker accept=".png, .pdf, .jpeg "
                                                className="e-select-file"
                                                error={cancelledChequeError}
                                                type={1}
                                                loading={fileLoader === 2 ? true : false}
                                                onSelectFile={_handleCheque} />
                                        ) : (
                                            <FilePreview fileName={cancelledCheque}
                                                clearFile={() => {
                                                    setCancelledCheque(null);
                                                    setCancelledChequeUrl("");
                                                }} />
                                        )
                                }
                            </div>
                        </div>
                        <div className="margin-32px-top">
                            {/* validation */}
                            <GradientButton label="Submit"
                                className="padding-12px-tb px-3 e-font-16"
                                loading={apiLoader}
                                onPress={_submitBankDetail} />
                        </div>
                    </div>
                </div>
            </>
            :
            <>
                {/* Form title */}
                <div className="row">
                    <div className="col-6">
                        <h5 className="color-jett-black e-poppins-medium e-font-16">Add bank details</h5>
                    </div>
                    <div className="col-6 text-end">
                        <LinkText title="Back to previous step"
                            iconPosition={1}
                            icon="back-arrow"
                            className="e-kcy-back-button"
                            onClick={_navigateBack} />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-12">
                        <h6 className="color-jett-black e-poppins-medium e-font-14">Bank details</h6>
                    </div>
                </div>

                {/* Form */}
                <div className="row mb-4">
                    <div className="col-lg-6 col-12 mt-4">
                        <CustomTextInput value={bankName}
                            label="Bank name"
                            postfix="*"
                            error={bankError}
                            onEnter={_validateBankDetail}
                            valueChange={(e) => { setBankName(e); setBankError('') }} />
                    </div>

                    <div className="col-lg-6 col-12 mt-4">
                        <CustomTextInput value={acNumber}
                            label="Account number"
                            postfix="*"
                            type="number"
                            error={acNumberError}
                            onEnter={_validateBankDetail}
                            valueChange={(e) => { setAcNumber(e); setAcNumberError('') }} />
                    </div>

                    <div className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomSearchSelectBox value={acType}
                            label="Account type"
                            postfix="*"
                            options={AC_TYPE}
                            onSelectChange={(e) => setAcType(e)} />
                    </div>

                    <div className="col-lg-6 col-12 mt-4 pt-3">
                        <CustomTextInput value={ifsc}
                            label="IFSC Code"
                            postfix="*"
                            error={ifscError}
                            max={12}
                            onEnter={_validateBankDetail}
                            valueChange={(e) => { setIfsc(e); setIfscError('') }} />
                    </div>
                </div>

                {/* Submit button */}
                <div className="row my-4">
                    <div className="col-12 text-center mt-3">
                        <GradientButton label="Save & continue"
                            // className="padding-12px-tb padding-16px-lr e-kyc-submit-button"
                            className="padding-12px-tb padding-16px-lr"
                            onPress={_validateBankDetail} />
                    </div>
                </div>
            </>
    )

}

export default BankDetail;
